import { aiUsageReportSchema } from '@acasa/shared'
import { useQuery } from '@tanstack/react-query'
import { API_PREFIX, apiFetch } from '@/lib/api'

/**
 * The KI-Nutzung report for one month — `null` asks for the current one, which
 * the SERVER decides in its reporting timezone, so the browser never has to
 * guess what "this month" means at 00:30 on the 1st.
 *
 * Admin-only on the server (403 otherwise), so the query is gated rather than
 * fired and caught, like the settings query beside it.
 */
export const aiUsageKey = ['ai-usage'] as const

export function useAiUsage(month: string | null, enabled: boolean) {
  return useQuery({
    queryKey: [...aiUsageKey, month ?? 'current'],
    queryFn: () =>
      apiFetch(
        month ? `/settings/ai-usage?month=${month}` : '/settings/ai-usage',
        aiUsageReportSchema,
      ),
    enabled,
    // Neighbouring months stay on screen while the next one loads, so the
    // month picker does not collapse the panel to "Wird geladen …" per click.
    placeholderData: (previous) => previous,
  })
}

/** The same month as a CSV — a plain link, so the browser handles the download. */
export function aiUsageCsvHref(month: string): string {
  return `${API_PREFIX}/settings/ai-usage.csv?month=${month}`
}
